





































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { StepKeys } from '../../variables/ACF_Key'
import Thumbs from '../../components/Thumbs.vue'
import Title from '../../components/Title.vue'
import MinThumbs from '../../components/MinThumb.vue'
import Wizard from '../Wizard.vue'
import Retour from '../../components/Retour.vue'
import Ctas from '../../components/Ctas.vue'
@Component({
  components: {
    Thumbs,
    Title,
    Wizard,
    MinThumbs,
    Retour,
    Ctas
  }
})
export default class Etape2 extends Vue {
  // Datas de la vue :
  public ready = false
  // Data a transmettre au titre :
  public titleMain!: string
  // Datas a transmettre au thumb :
  public item1!: string
  public item2!: string
  public item3!: string
  public item4!: string
  public surface = ''
  // Vue actuelle
  public step = 3
  //* ************ <!>IMPORTANT<!> -> Object pour enregistrer le JSON récupéré par AXIOS
  public responseACF!: Record<string, string>
  sortACFForThisView (): void {
    // Appel la class permettant de lire le trie du JSON (API WP)
    const thumbInfo = new StepKeys(this.responseACF)
    if (thumbInfo) {
      // Ajouter la clef ACF des items de la vue
      /***
       * INFO si dessous à modifier celon le projet :
       */
      this.item1 = thumbInfo.getValue('it_was_a_1')
      this.item2 = thumbInfo.getValue('it_was_a_2')
      this.item3 = thumbInfo.getValue('it_was_a_3')
      this.item4 = thumbInfo.getValue('it_was_a_4')
      /***
       * Titre de la vue :
       */
      this.titleMain = thumbInfo.getSimpleValue('it_was_a_title')
      this.ready = true
    }
  }

  // Envoie les data des radios buttons a vueX
  sendData (value: string, event: EventTarget): void {
    if (event && value) {
      const containerInput = document.querySelector(
        '.container_input_tunnel_item'
      )
      if (containerInput) {
        const allInput = containerInput.querySelectorAll('input')
        const currentInput = containerInput.querySelector(
          "input[value='" + value + "']"
        )

        if (allInput && currentInput) {
          allInput.forEach((input) => {
            if (input.isEqualNode(currentInput)) {
              input.checked = true
            } else {
              input.checked = false
            }
          })

          this.$store.dispatch('saveStep3RadioButton', value)
        }
      }
    }
  }

  saveSurface (): void {
    if (this.surface) {
      this.$store.dispatch('saveSurface', this.surface)
    }
  }

  /***
   * VUE STATE =>
   */
  mounted (): void {
    this.responseACF = this.$store.getters.getValueOfACF
    // Plus besoin de requetter l'api à partir de cette vue car la valeur des ACFs sont stockées dans le vuex
    if (this.responseACF) {
      this.sortACFForThisView()
    }
  }

  @Watch('surface')
  onPropertyChanged (): void {
    // console.log('changeSurface')
    this.saveSurface()
  }
}
